import React from 'react';

// The detail line under an item row (docs/bands-spec.md §6.2), drawn the way
// the PDF draws it: each "Label: value" as a boxed label ("chips") or all of
// them joined by the separator ("text"). `valueOf(field)` gives the row's
// value for a field; the canvas passes {Field} placeholders instead.
export default function DetailRowLine({ detailRow, valueOf }) {
    if (!detailRow) return null;
    const font = detailRow.font || {};
    const chip = detailRow.chipStyle || {};

    const parts = (detailRow.segments || [])
        .filter((segment) => segment && segment.field)
        .map((segment) => {
            const value = valueOf(segment.field);
            const empty = value === undefined || value === null || String(value).trim() === '';
            return empty && detailRow.hideEmpty ? null : `${segment.label ? segment.label + ': ' : ''}${empty ? '' : value}`;
        })
        .filter((part) => part !== null);

    // Line height 1.25, as getTableMetrics sizes the detail line, so the
    // canvas, the preview and the PDF give it the same height.
    const textStyle = {
        fontFamily: font.fontFamily || 'Inter',
        fontSize: (font.fontSize || 7) + 'pt',
        lineHeight: 1.25,
        color: font.color || '#6B7280',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    };

    if (detailRow.style === 'text') {
        return <div style={{ ...textStyle, textOverflow: 'ellipsis' }}>{parts.join(detailRow.separator ?? ' · ')}</div>;
    }

    return (
        <div style={{ ...textStyle, display: 'flex', gap: '6px' }}>
            {parts.map((part, i) => (
                <span
                    key={i}
                    style={{
                        // Set here too: a global `* { font-size }` rule would
                        // otherwise override the size inherited from above.
                        fontSize: textStyle.fontSize,
                        display: 'inline-block',
                        background: chip.background || 'transparent',
                        border: (chip.borderWidth ?? 1) > 0 ? `${chip.borderWidth ?? 1}px solid ${chip.borderColor || '#E5E7EB'}` : 'none',
                        borderRadius: (chip.borderRadius ?? 3) + 'px',
                        padding: `${chip.paddingY ?? 1}px ${chip.paddingX ?? 6}px`,
                    }}
                >
                    {part}
                </span>
            ))}
        </div>
    );
}
